"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExportService = void 0;
var _export = require("../controllers/export.controller");
var ExportService = {
  reportDataExport: {
    fundExportDownload: _export.config.reportDataExport + "/fund",
    fundTypeExportDownload: _export.config.reportDataExport + "/fund/type",
    fundPerformanceExport: _export.config.reportDataExport + "/performance",
    fundDonorExport: _export.config.reportDataExport + "/donor",
    fundImpactExport: _export.config.reportDataExport + "/impact",
    impactTypeExport: _export.config.reportDataExport + "/impact/type",
    fundDistributionList: _export.config.reportDataExport + "/distribution",
    fundReportPrintBridge: _export.config.printBridgeExport + "/report"
  },
  analyticDataExport: {
    recordsExportDownload: _export.config.analyticDataExport + "/snapshot",
    recordsExportDownloadSite: _export.config.exportData + "/site/snapshot/live",
    recordsExportDownloadReport: _export.config.exportData + "/report/snapshot/live",
    systemWideDataExportDownload: _export.config.analyticDataExport + "/site-report/system-wide-data"
  },
  archiveExport: {
    findArchiveList: _export.config.archiveExport + "/list",
    deleteArchiveByArchive: _export.config.archiveExport,
    exportDownloadFromArchive: _export.config.archiveExport + "/download"
  },
  platformExport: {
    exportAllTenantUserDetails: _export.config.platformExport
  },
  templateExport: {
    download: _export.config.templateExport
  },
  systemDataExport: {
    recordExportDownload: _export.config.systemDataExport + "/record",
    userExportDownload: _export.config.systemDataExport + "/user",
    userActivityExportDownload: _export.config.systemDataExport + "/user-activity",
    changeLogExportDownload: _export.config.systemDataExport + "/log"
  },
  surveyExport: {
    download: _export.config.surveyExport + "/data-schema"
  }
};
exports.ExportService = ExportService;